import CanvasJSReact from '../../assets/jss/canvasjs.react.js'
import React from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import $ from 'jquery'
import datepickerFactory from 'jquery-datepicker'
// react plugin for creating charts
import ChartistGraph from 'react-chartist'
import withStyles from '@material-ui/core/styles/withStyles'
import Icon from '@material-ui/core/Icon'
import DateRange from '@material-ui/icons/DateRange'
import AccessTime from '@material-ui/icons/AccessTime'
import GridItem from 'components/Grid/GridItem.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import Card from 'components/Card/Card.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardFooter from 'components/Card/CardFooter.jsx'
import Button from '@material-ui/core/Button'
import { Spinner } from 'react-bootstrap'

import axios from 'axios'
import headers from '../../config/token.js'
import settings from '../../config/setting-values'

import '../../assets/css/Dashboard/Dashboard.scss'
import '../../assets/css/Dashboard/jquery-ui.scss'

import authClient from 'services/Auth.js'

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart,
  CTRConversionChart
} from 'variables/charts.jsx'

import dashboardStyle from 'assets/jss/material-dashboard-react/views/dashboardStyle.jsx'
axios.defaults.withCredentials = false
datepickerFactory($)

const CanvasJSChart = CanvasJSReact.CanvasJSChart

class Dashboard extends React.Component {
  constructor (props) {
    super(props)
    const currentDate = new Date()
    const date = new Date()
    date.setDate(date.getDate() - 7)

    this.state = {
      currentAnalytics: null,
      analyticsEnd: this.convertDate(currentDate),
      analyticsStart: this.convertDate(date),
      showTables: false,
      showGraphs: false,
      graphData: [],
      currentAnalyticsloading: false,
      graphLoading: false
    }

    this.getAnalytics = this.getAnalytics.bind(this)
    this.handleGetDataClick = this.handleGetDataClick.bind(this)
    this.handleDatetimeChange = this.handleDatetimeChange.bind(this)
    this.calculateGraphs = this.calculateGraphs.bind(this)
    this.fetchAnalytics = this.fetchAnalytics.bind(this)
    this.transformData = this.transformData.bind(this)
    this.converDate = this.convertDate.bind(this)

  }

  convertDate (date) {
    return date.getFullYear() +
      '-' +
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : '0' + (date.getMonth() + 1)) +
      '-' +
      (date.getDate() > 9
        ? date.getDate()
        : '0' + date.getDate())
  }

  async componentDidMount () {
    const datepicker = document.getElementsByClassName('datepicker')
    const jQuery = $
    for (let i = 0; i < 2; i++) {
      if (datepicker[i].type !== 'date') { // if browser doesn't support input type="date", initialize date picker widget:
        jQuery(($) => { // on document.ready
          $('#' + datepicker[i].id).datepicker({
            dateFormat: 'yy-mm-dd',
            onSelect: (date) => {
              this.handleDatetimeChange({
                target: {
                  value: date,
                  name: datepicker[i].name
                }
              })
            }
          })
        })
      }
    }
    jQuery(function ($) {
      $('.ui-helper-clearfix').css('display', 'none')
      // $.datepicker.onSelect()
    })
    await this.getAnalytics()
  }

  async handleDatetimeChange (event) {
    const dateVal = event.target.value
    await this.setState({ [event.target.name]: dateVal })
  }

  async handleGetDataClick (event) {
    event.preventDefault()
    await this.getAnalytics()
  }

  async fetchAnalytics (startDate, endDate) {
    console.log({startDate, endDate});
    axios.defaults.withCredentials = false
    const service = axios.create({
      baseURL: settings.analyticsEndpoint,
      withCredentials: false,
      headers: headers
    })
    const response = await service
      .post('/v4/getAnalyticsFormatted', {
        start_date: startDate
          .split('-')
          .reverse()
          .join('-'),
        end_date: endDate
          .split('-')
          .reverse()
          .join('-')
      })
      .catch(err => console.log(err))
    return response
  }

  async calculateGraphs () {
    const dataPoints = []
    const startDate = new Date(this.state.analyticsStart)
    const endDate = new Date(this.state.analyticsEnd)
    let startTime = startDate.getTime()
    var controlTime = startTime + 86400000
    let cancelled = false

    while (startTime < endDate.getTime()) {
      if (window.location.pathname !== '/admin/dashboard') {
        cancelled = true
        break
      }
      const startDateUnix = new Date(startTime)
      const controlDateUnix = new Date(controlTime)
      const startDateMm = this.convertDate(startDateUnix)
      const endDateMm = this.convertDate(controlDateUnix)

      const results = await this.fetchAnalytics(startDateMm, endDateMm)
      startTime += 86400000
      controlTime += 86400000
      if (results !== undefined) {
        dataPoints.push(results.data)
      }
    }
    if (!cancelled) {
      await this.setState({ graphData: dataPoints, graphLoading: false, showGraphs: true })
      this.chart1.render()
      this.chart2.render()
      this.chart3.render()
      this.chart4.render()

      this.chart7.render()
      this.chart8.render()
    }
  }

  async getAnalytics () {
    //  check if dates entered are valid and not null
    const startAndEndDateGiven =
      this.state.analyticsEnd !== null && this.state.analyticsStart !== null
    const startDateSmallerThanEndDate =
      new Date(this.state.analyticsStart) <= new Date(this.state.analyticsEnd)

    if (startAndEndDateGiven && startDateSmallerThanEndDate) {
      await this.setState({ currentAnalyticsloading: true, graphLoading: true })
      // format of date needs to be reversed (e.g. 2019-08-17 => 17-08-2019)
      // TODO This is just for demo purposes, modify in the future
      const service = axios.create({
        baseURL: settings.analyticsEndpoint,
        withCredentials: false,
        headers: headers
      })
      const response = await service
        .post('/v4/getAnalyticsFormatted', {
          start_date: this.state.analyticsStart
            .split('-')
            .reverse()
            .join('-'),
          end_date: this.state.analyticsEnd
            .split('-')
            .reverse()
            .join('-')
        })
        .catch(err => console.log(err))
      if (response !== undefined) {
        await this.setState({ currentAnalytics: response.data, currentAnalyticsloading: false })
        this.calculateGraphs()
      }
    }
  }

  // show larger number in oomma notation format <23,000>
  formatNumber (number) {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  transformData (data, arg) {
    const returnData = []
    data.forEach((element, index, array) => {
      returnData.push({ x: index + 1, y: element[arg] })
    })
    return returnData
  }

  render () {
    const options1 = {
      title: {
        text: 'Outfit Impressions'
      },
      axisY: {
        title: 'Outfit Impresssions',
        includeZero: false,
        suffix: ''
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Dat {x}: {y}',
          dataPoints: this.transformData(
            this.state.graphData,
            'Outfit Impressions'
          )
        }
      ]
    }

    const options2 = {
      title: {
        text: 'Outfit CTR'
      },
      axisY: {
        title: 'Outfit CTR',
        includeZero: true,
        suffix: '%'
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Day {x}: {y}%',
          dataPoints: this.transformData(this.state.graphData, 'Outfit CTR')
        }
      ]
    }
    const options3 = {
      title: {
        text: 'Similarity Impressions'
      },
      axisY: {
        title: 'Similarity Impressions',
        includeZero: true,
        suffix: ''
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Day {x}: {y}',
          dataPoints: this.transformData(
            this.state.graphData,
            'Similarity Impressions'
          )
        }
      ]
    }
    const options4 = {
      title: {
        text: 'Similarity CTR'
      },
      axisY: {
        title: 'Similarity CTR',
        includeZero: true,
        suffix: '%'
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Day {x}: {y}%',
          dataPoints: this.transformData(this.state.graphData, 'Similarity CTR')
        }
      ]
    }
    const options7 = {
      title: {
        text: 'Personalisation Impressions'
      },
      axisY: {
        title: 'Personalisation Impressions',
        includeZero: true,
        suffix: ''
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Day {x}: {y}',
          dataPoints: this.transformData(
            this.state.graphData,
            'Personalisation Impressions'
          )
        }
      ]
    }
    const options8 = {
      title: {
        text: 'Personalisation CTR'
      },
      axisY: {
        title: 'Personalisation CTR',
        includeZero: true,
        suffix: '%'
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Day {x}: {y}%',
          dataPoints: this.transformData(this.state.graphData, 'Personalisation CTR')
        }
      ]
    }

    const options5 = {
      title: {
        text: 'Total Amount of Sales'
      },
      axisY: {
        title: 'Total Amount of Sales',
        includeZero: true,
        suffix: '$'
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Day {x}: {y}$',
          dataPoints: this.transformData(
            this.state.graphData,
            'Total Amount of Sales'
          )
        }
      ]
    }

    const options6 = {
      title: {
        text: 'Total Number of Sales'
      },
      axisY: {
        title: 'Total Number of Sales',
        includeZero: true,
        suffix: ''
      },
      axisX: {
        title: 'Day of period',
        prefix: 'D',
        interval: 1
      },
      data: [
        {
          type: 'line',
          toolTipContent: 'Day {x}: {y}',
          dataPoints: this.transformData(
            this.state.graphData,
            'Total Number of Sales'
          )
        }
      ]
    }

    const { classes } = this.props

    if (authClient.isAuthenticated()) {
      return (
        <div>
          <div
            style={{ marginBottom: '25px' }}
            className='dashboard-date-input-container'
          >
            <label htmlFor='start'>Start date:</label>
            <input
              className={`form-control datepicker ${classes.dateCustom}`}
              type='date'
              id='start'
              name='analyticsStart'
              onChange={e => this.handleDatetimeChange(e)}
              value={this.state.analyticsStart}
            />
            <label htmlFor='start' style={{ marginLeft: '20px' }}>
              End date:
            </label>
            <input
              className={`form-control datepicker ${classes.dateCustom}`}
              type='date'
              id='end'
              name='analyticsEnd'
              onChange={e => this.handleDatetimeChange(e)}
              value={this.state.analyticsEnd}
            />
            <Button
              color='secondary'
              style={{ marginLeft: '20px' }}
              variant='contained'
              onClick={this.handleGetDataClick}
            >
              Get Data
            </Button>
          </div>
          {this.state.currentAnalyticsloading
            ? <div className={classes.loadingSpinner}>
              <Spinner
                animation='border'
                role='status'
              >
                <span className='sr-only'>Loading...</span>
              </Spinner>
            </div>
            : this.state.currentAnalytics && (
              <GridContainer>
                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='warning' stats icon>
                      <CardIcon color='warning'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>Intelistyle AOV</p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Intelistyle AOV']
                          ? this.state.currentAnalytics[
                            'Intelistyle AOV'
                          ].toFixed(2)
                          : 0}{' '}
                        <small>$</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='danger' stats icon>
                      <CardIcon color='danger'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>
                        Intelistyle Amount of Sales
                      </p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics[
                          'Intelistyle Amount of Sales'
                        ]
                          ? this.state.currentAnalytics[
                            'Intelistyle Amount of Sales'
                          ].toFixed(2)
                          : 0}{' '}
                        <small>$</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='success' stats icon>
                      <CardIcon color='success'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>
                        Intelistyle Conversion
                      </p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Intelistyle Conversion']
                          ? this.state.currentAnalytics[
                            'Intelistyle Conversion'
                          ].toFixed(2)
                          : 0}{' '}
                        <small>%</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='primary' stats icon>
                      <CardIcon color='primary'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>
                        Intelistyle Number of Sales
                      </p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics[
                          'Intelistyle Number of Sales'
                        ]
                          ? this.state.currentAnalytics[
                            'Intelistyle Number of Sales'
                          ]
                          : 0}
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='rose' stats icon>
                      <CardIcon color='rose'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>
                        Intelistyle Sales Percentage
                      </p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics[
                          'Intelistyle Sales Percentage'
                        ]
                          ? this.state.currentAnalytics[
                            'Intelistyle Sales Percentage'
                          ].toFixed(2)
                          : 0}{' '}
                        <small>%</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='info' stats icon>
                      <CardIcon color='info'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>Outfit CTR</p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Outfit CTR']
                          ? this.state.currentAnalytics['Outfit CTR'].toFixed(2)
                          : 0}{' '}
                        <small>%</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='success' stats icon>
                      <CardIcon color='success'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>Outfit Impressions</p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Outfit Impressions']
                          ? this.state.currentAnalytics['Outfit Impressions']
                          : 0}
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='info' stats icon>
                      <CardIcon color='info'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>Personalisation CTR</p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Personalisation CTR']
                          ? this.state.currentAnalytics['Personalisation CTR'].toFixed(2)
                          : 0}{' '}
                        <small>%</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='success' stats icon>
                      <CardIcon color='success'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>Personalisation Impressions</p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Personalisation Impressions']
                          ? this.state.currentAnalytics['Personalisation Impressions']
                          : 0}
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>


                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='danger' stats icon>
                      <CardIcon color='danger'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>Similarity CTR</p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Similarity CTR']
                          ? this.state.currentAnalytics['Similarity CTR'].toFixed(
                            2
                          )
                          : 0}{' '}
                        <small>%</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='info' stats icon>
                      <CardIcon color='info'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>
                        Similarity Impressions
                      </p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Similarity Impressions']
                          ? this.state.currentAnalytics['Similarity Impressions']
                          : 0}
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='warning' stats icon>
                      <CardIcon color='warning'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>Total AOV</p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Total AOV']
                          ? this.state.currentAnalytics['Total AOV'].toFixed(2)
                          : 0}{' '}
                        <small>$</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='info' stats icon>
                      <CardIcon color='info'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>
                        Total Amount of Sales
                      </p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Total Amount of Sales']
                          ? this.state.currentAnalytics[
                            'Total Amount of Sales'
                          ].toFixed(2)
                          : 0}{' '}
                        <small>$</small>
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>

                <GridItem xs={12} sm={6} md={4}>
                  <Card>
                    <CardHeader color='primary' stats icon>
                      <CardIcon color='primary'>
                        <Icon>content_copy</Icon>
                      </CardIcon>
                      <p className={classes.cardCategory}>
                        Total Number of Sales
                      </p>
                      <h3 className={classes.cardTitle}>
                        {/* Handling case that API call does not return all fields */}
                        {this.state.currentAnalytics['Total Number of Sales']
                          ? this.state.currentAnalytics['Total Number of Sales']
                          : 0}
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <DateRange />
                        Selected period aggregate
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>
              </GridContainer>
            )}
          {this.state.showTables && (
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader color='warning'>
                    <ChartistGraph
                      className='ct-chart'
                      data={CTRConversionChart.data}
                      type='Line'
                      options={CTRConversionChart.options}
                      responsiveOptions={CTRConversionChart.responsiveOptions}
                      listener={CTRConversionChart.animation}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}>CTR</h4>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> updated 4 minutes ago
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader color='success'>
                    <ChartistGraph
                      className='ct-chart'
                      data={CTRConversionChart.data}
                      type='Line'
                      options={CTRConversionChart.options}
                      responsiveOptions={CTRConversionChart.responsiveOptions}
                      listener={CTRConversionChart.animation}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}>Conversion</h4>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> updated 4 minutes ago
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader color='danger'>
                    <ChartistGraph
                      className='ct-chart'
                      data={dailySalesChart.data}
                      type='Line'
                      options={dailySalesChart.options}
                      listener={dailySalesChart.animation}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}>AOV</h4>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> updated 4 minutes ago
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader color='info'>
                    <ChartistGraph
                      className='ct-chart'
                      data={emailsSubscriptionChart.data}
                      type='Line'
                      options={emailsSubscriptionChart.options}
                      responsiveOptions={
                        emailsSubscriptionChart.responsiveOptions
                      }
                      listener={emailsSubscriptionChart.animation}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}>
                      Intelistyle Sales Percentage
                    </h4>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> updated 4 minutes ago
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader color='primary'>
                    <ChartistGraph
                      className='ct-chart'
                      data={completedTasksChart.data}
                      type='Line'
                      options={completedTasksChart.options}
                      listener={completedTasksChart.animation}
                    />
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}>Intelistyle Sales</h4>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> updated 4 minutes ago
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          )}
          {this.state.graphLoading
            ? <div className={classes.loadingSpinner}>
              <Spinner
                animation='border'
                role='status'
              >
                <span className='sr-only'>Loading...</span>
              </Spinner>
            </div>
            : this.state.showGraphs && (

              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options1}
                        onRef={ref => {
                          this.chart1 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options2}
                        onRef={ref => {
                          this.chart2 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options3}
                        onRef={ref => {
                          this.chart3 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options4}
                        onRef={ref => {
                          this.chart4 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options7}
                        onRef={ref => {
                          this.chart7 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options8}
                        onRef={ref => {
                          this.chart8 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options5}
                        onRef={ref => {
                          this.chart3 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <Card>
                    <div>
                      <CanvasJSChart
                        options={options6}
                        onRef={ref => {
                          this.chart4 = ref
                        }}
                      />
                    </div>
                  </Card>
                </GridItem>
              </GridContainer>
            )}
        </div>
      )
    } else {
      return <Redirect to='/login' />
    }
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(dashboardStyle)(Dashboard)
